import pako from 'pako';
import { Base64 } from 'js-base64';

export function encodeData(data: any): string {
  const minimized = data.map(filter => {
    const min: any = {
      n: filter.name,
      o: filter.operator,
      t: filter.type,
      v: filter.value,
    };

    if (filter.integer) min.i = filter.integer;
    if (filter.isEvidence !== undefined) min.e = filter.isEvidence;
    if (filter.dir) min.d = filter.dir;

    return min;
  });

  const json = JSON.stringify(minimized);
  const compressed = pako.deflate(json);
  return Base64.fromUint8Array(compressed, true);
}

export function decodeData(token: string): any {
  try {
    if (!token) return [];

    const compressed = Base64.toUint8Array(token);
    const json = pako.inflate(compressed, { to: 'string' });
    const data = JSON.parse(json);

    if (data[0]?.name) {
      return data;
    }

    return data.map(filter => {
      const restored: any = {
        name: filter.n,
        operator: filter.o,
        type: filter.t,
        value: filter.v,
      };

      if (filter.i !== undefined) restored.integer = filter.i;
      if (filter.e !== undefined) restored.isEvidence = filter.e;
      if (filter.d) restored.dir = filter.d;

      return restored;
    });
  } catch (error) {
    console.error('Error decoding filter token:', error);
    return [];
  }
}
